(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('MailExplorerNew', ["$q", "$scope", "options", "$rootScope", "$timeout", "$modal", "path", "tablePaginationHelper", "defaultListConverter", "apAvananExceptionsDao", "mailExplorerDao", "$routeParams", "modals", "manualActionDao", "modulesManager", "routeHelper", "columnsHelper", "apExceptionsConfirmModal", "configDao", "feature", function ($q, $scope, options, $rootScope, $timeout, $modal, path, tablePaginationHelper, defaultListConverter, apAvananExceptionsDao, mailExplorerDao, $routeParams, modals, manualActionDao, modulesManager, routeHelper, columnsHelper, apExceptionsConfirmModal, configDao, feature) {
        $scope.loading = true;
        $scope.error = '';
        $scope.params = [];
        $scope.loaded = false;
        $scope.ruleToBeCreated = null;
        $scope.model = {
            currentModule: $routeParams.module,
            scopeParams: {},
            typeof: function (obj) {
                return typeof obj;
            }
        };
        $scope.pageContext = options.mode;
        $scope.ruleTypeContext = options.type;
        $scope.enabledMe2ES = false;
        $scope.operator = false;
        $scope.enableOperatorSwitch = $scope.pageContext !== 'page' && feature.enableMailExplorerOperator && window.location.href.indexOf('/profile') !== -1;
        $scope.operatorTip = 'Type of operation between match criteria: All - match all search criteria (subject AND sender AND\u2026); Any - match any search criteria (subject OR sender OR...)';
        $scope.isEntityPageModal = $scope.pageContext !== 'page' && window.location.href.indexOf('/profile') !== -1;
        $scope.currentEntityData = {};
        var eventsUpdating = {};
        var exception_type_to_name = {
            blacklist: 'Block-List',
            whitelist: 'Allow-List'
        };
        function setParam(values, param, theParamId) {
            if (Array.isArray(values[theParamId])) {
                if (values[theParamId].length !== 1) {
                    return false;
                }
                if (theParamId === 'attachments') {
                    param.data = values[theParamId][0].MD5;
                    param.is_active = true;
                    return false;
                }
                if (theParamId !== 'recipient') {
                    param.data = values[theParamId][0];
                }
                param.is_active = true;
                return false;
            }
            if (theParamId !== 'recipient') {
                param.data = values[theParamId];
            }
            param.is_active = true;
            return true;
        }
        function setParamMatch(values, param) {
            var matchData = '';
            if (values[param.id + '_matching']) {
                matchData = values[param.id + '_matching'];
            }
            if (values[param.id + '_ends_with']) {
                matchData = values[param.id + '_ends_with'];
            }
            // if (values[param.detailsId + '_matching']) {
            //     matchData = values[param.id + '_matching'];
            // }
            if (values[param.detailsId + '_ends_with']) {
                matchData = values[param.id + '_ends_with'];
            }
            if (values[param.exceptionRuleId + '_matching']) {
                matchData = values[param.id + '_matching'];
            }
            if (values[param.exceptionRuleId + '_ends_with']) {
                matchData = values[param.id + '_ends_with'];
            }
            if (param.exceptionRuleId === 'with_links_to_domains' && values.email_link_matching) {
                matchData = values.email_link_matching;
            }
            if (matchData) {
                param.match = matchData;
            }
        }
        function setParams(values) {
            if (values.received_at) {
                $scope.specific_datetime = values.received_at;
            }
            _($scope.params).chain().map(function (param) {
                if (param.id == 'entity_id' || param.id == 'entity_type') {
                    return;
                }
                var theParamId = param.detailsId || param.id;
                if (!values[theParamId] && values[param.id]) {
                    theParamId = param.id;
                }
                if (typeof values[param.id] == 'string' && values[param.id].startsWith('fe80:')) {
                    return;
                }
                setParamMatch(values, param);
                var flag = false;
                if (values[theParamId]) {
                    flag = setParam(values, param, theParamId);
                    if (!flag) {
                        return;
                    }
                }
                theParamId = param.exceptionRuleId;
                if (theParamId && values[theParamId]) {
                    flag = setParam(values, param, theParamId);
                    if (!flag) {
                        return;
                    }
                }
                if (theParamId === 'with_links_to_domains') {
                    theParamId = 'email_link';
                    if (theParamId && values[theParamId]) {
                        setParam(values, param, theParamId);
                    }
                }
            });
            $scope.refreshTable();
        }
        function setValues() {
            if (options && options.entityType && options.entityId) {
                mailExplorerDao.searchEmails2({
                    entity_type: options.entityType,
                    entity_id: options.entityId
                }).then(function (response) {
                    if (response.data && response.data.rows && response.data.rows[0]) {
                        $scope.currentEntityData = response.data.rows[0];
                    }
                    if (response.data.rows || response.data.rows[0]) {
                        var values = response.data.rows[0];
                        setParams(values);
                    }
                });
            } else if (options && options.columns && typeof options.columns === 'object') {
                setParams(options.columns);
            } else {
                $scope.refreshTable();
            }
        }
        var refreshDelay = null;
        var ipRegex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;
        var changedCount = 0;
        var skippedFirstRefresh = false;
        $scope.emptySearch = true;
        var lastParamsValues = [];
        $scope.checkParamsChanged = function () {
            if (!_.isEqual(lastParamsValues, $scope.params)) {
                // changed
                lastParamsValues = _($scope.params).chain().map(function (param) {
                    if (!param.is_active) {
                        param.readOnly = true;
                    } else {
                        param.readOnly = false;
                    }
                    return _.clone(param);
                }).value();
                reportChange();
            }
        };
        var reportChange = function () {
            $scope.loading = true;
            changedCount += 1;
            $timeout(function () {
                changedCount -= 1;
                if (changedCount === 0) {
                    if (!skippedFirstRefresh) {
                        skippedFirstRefresh = true;
                        return;
                    }
                    $scope.refreshTable();
                }
            }, 1000);
        };
        $scope.onChangeParam = function (param) {
            $scope.checkParamsChanged();
            // update valid state
            if (param.validation) {
                if (isParamValid(param)) {
                    param.valid = true;
                } else {
                    param.valid = false;
                }
            }
            if (!$scope.model.scopeParams[param.id]) {
                $scope.model.scopeParams[param.id] = {};
            }
            $scope.model.scopeParams[param.id].data = param.data;
        };
        $scope.onChangeOperator = function (operator) {
            $scope.operator = operator;
            $scope.refreshTable();
        };
        $scope.uncheckAll = function () {
            if ($scope.params && $scope.params.length) {
                _($scope.params).each(function (param) {
                    if (param.group === 1) {
                        return;
                    }
                    param.is_active = false;
                });
            }
        };
        $scope.onChangeParamMatching = function (id, match) {
            if (!$scope.model.scopeParams[id]) {
                $scope.model.scopeParams[id] = {};
            }
            $scope.model.scopeParams[id].match = match;
        };
        $scope.updateSearchStatus = function () {
            var isEmptySearch = true;
            $scope.params.forEach(function (param) {
                if (param.id != 'range_from' && param.id != 'range_to') {
                    if (param.data) {
                        isEmptySearch = false;
                        return;
                    }
                }
            });
            $scope.emptySearch = isEmptySearch;
        };
        $scope.matchParam = {
            id: 'matchParam',
            type: 'selector',
            data: 'contains',
            paramClass: 'match-param',
            variants: [
                {
                    id: 'contains',
                    label: 'Contains'
                },
                {
                    id: 'exact',
                    label: 'Match'
                }
            ]
        };
        $scope.matchParam1 = {
            id: 'matchParam',
            type: 'selector',
            data: 'contains',
            paramClass: 'match-param',
            variants: [
                {
                    id: 'contains',
                    label: 'Ends With'
                },
                {
                    id: 'exact',
                    label: 'Match'
                }
            ]
        };
        var availableSaases = ['office365_emails'];
        modulesManager.init().then(function () {
            $scope.enabledSaases = _(modulesManager.activeSaasApps()).filter(function (saas) {
                return _(availableSaases).contains(saas.name);
            });
        });
        var currentModule = $routeParams.module;
        var moduleToEntityType = {
            google_mail: 'google_mail_email',
            office365_emails: 'office365_emails_email'
        };
        var actionName = {
            quarantine: {
                google_mail_email: {
                    attributes: { email: '{google_mail_email}' },
                    name: 'google_mail_email_quarantine'
                },
                office365_emails_email: {
                    attributes: { email: '{office365_emails_email}' },
                    name: 'office365_emails_email_quarantine'
                }
            },
            release: {
                google_mail_email: {
                    attributes: { email: '{google_mail_email}' },
                    name: 'google_mail_email_restore'
                },
                office365_emails_email: {
                    attributes: { email: '{office365_emails_email}' },
                    name: 'office365_emails_email_restore'
                }
            }
        };
        function displayExceptionModal(exception_type) {
            if (!isFormValid()) {
                return modals.confirm({
                    message: _($scope.errorsList).join('<br>'),
                    title: 'Illegal Input',
                    cancelText: 'Cancel'
                });
            }
            var exceptionRule = {};
            exceptionRule.exception_type = exception_type;
            var actionWord = exception_type == 'blacklist' ? 'phishing' : 'clean';
            var params = [];
            _($scope.params).chain().map(function (param) {
                if (!param.is_active || param.enabled === false || !param.isBlacklistCondition || !param.data) {
                    return;
                }
                params.push({
                    type: 'message',
                    message: '#' + JSON.stringify({
                        display: 'html',
                        text: '<strong>' + param.label + (param.match ? ' (' + param.match + ')' : '') + '</strong>' + ': ' + param.data
                    })
                });
                var theId = param.exceptionRuleId || param.detailsId || param.id;
                var theMatchingId = param.exceptionRuleId || param.id;
                exceptionRule[theId] = param.data;
                if (param.match) {
                    exceptionRule[(param.match_id || theMatchingId) + '_matching'] = param.match;
                    if (param.exceptionRuleId === 'with_links_to_domains') {
                        exceptionRule.link_matching = param.match;
                    }
                    if (theId === 'nickname') {
                        exceptionRule.from_name_macthing = param.match;
                    }
                }
            });
            if (params.length === 0) {
                return modals.params([{
                        lastPage: true,
                        label: 'Please select filter scope',
                        params: [
                            {
                                type: 'message',
                                message: 'A ' + exception_type_to_name[exception_type] + ' rule can not be empty!'
                            },
                            {
                                type: 'message',
                                message: 'Please insert data in the filters section in order to create a ' + exception_type_to_name[exception_type] + ' rule.'
                            }
                        ]
                    }], 'Create ' + exception_type_to_name[exception_type] + ' rule').then(function (data) {
                });
            }
            if (exception_type === 'whitelist' && !exceptionRule.sender_address && !exceptionRule.sender_ip && !exceptionRule.nickname && !exceptionRule.from_domain && !exceptionRule.sender_domain_suffix) {
                return modals.params([{
                        lastPage: true,
                        label: 'Please select filter scope',
                        params: [
                            {
                                type: 'message',
                                message: 'A ' + exception_type_to_name[exception_type] + ' rule can not be created!'
                            },
                            {
                                type: 'message',
                                message: 'Please insert data in one of "Sender Email", "Sender Name", "Sender SMTP" and "Sender Domain" at least in order to create a ' + exception_type_to_name[exception_type] + ' rule.'
                            }
                        ]
                    }], 'Create ' + exception_type_to_name[exception_type] + ' rule').then(function (data) {
                });
            }
            return apExceptionsConfirmModal.show({
                title: 'Create ' + exception_type_to_name[exception_type] + ' rule',
                exception_type: exception_type,
                disableCloseX: true,
                list: params,
                total: $scope.totalEmails
            }).then(function (data) {
                if (data && data.length) {
                    _(data).each(function (val, key) {
                        exceptionRule[val.id] = val.data;
                    });
                }
                // TODO: quarantine/release action
                if ($scope.totalEmails <= $scope.tableOptions.pagination.pageSize) {
                } else {
                }
                exceptionRule.match_only_future = false;
                var search_to_rule_keys_mapping = {
                    attach_md5: 'attachment_md5',
                    link: 'email_link'
                };
                _(exceptionRule).map(function (value, key) {
                    if (search_to_rule_keys_mapping[key]) {
                        exceptionRule[search_to_rule_keys_mapping[key]] = value;
                    }
                });
                var q;
                switch (exception_type) {
                case 'whitelist':
                    setAsWhitelistRule(exceptionRule);
                    q = apAvananExceptionsDao.add2(exceptionRule);
                    break;
                case 'blacklist':
                    q = apAvananExceptionsDao.blacklistCreate2(exceptionRule);
                    break;
                default:
                    q = apAvananExceptionsDao.blacklistCreate2(exceptionRule);
                    break;
                }
                q.then(function () {
                    $scope.closeModal();
                });
            });
        }
        function setAsWhitelistRule(data) {
            var keysSwap = {
                nickname: 'nicknames',
                sender_client_ip: 'ips',
                sender_domain_suffix: 'domains',
                sender_address: 'emails'
            };
            var keysThatNeedsToBeAnArray = [
                'nicknames',
                'ips',
                'domains',
                'emails',
                'recipient'
            ];
            _(data).map(function (value, key) {
                // swap keys
                if (keysSwap[key]) {
                    data[keysSwap[key]] = value;
                }
            });
            _(data).map(function (value, key) {
                // wrap inside an array
                if (keysThatNeedsToBeAnArray.includes(key)) {
                    data[key] = [value];
                }
            });
        }
        $scope.options = {
            columns: [],
            options: {
                defaultOrdering: {
                    columnName: 'received_at',
                    order: 'desc'
                },
                checkboxes: true
            },
            entityType: moduleToEntityType[currentModule]
        };
        $scope.tableOptions = {
            disableTop: true,
            resetSelectedOnPageChange: true,
            orderDisplayMode: 'highlight-column',
            infinite: true,
            limitLoadMore: true,
            asDivs: true,
            disableTotalRows: true,
            reloadUuid: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            pagesAround: 2,
            pagination: {
                pageSize: 50,
                ordering: {}
            },
            dropdownHeader: true
        };
        $scope.createException = function (exception_type) {
            displayExceptionModal(exception_type);
        };
        $scope.quarantine = function () {
            var selected = $scope.tableHelper && $scope.tableHelper.getSelectedIdsArray();
            if (!selected || !selected.length) {
                return modals.alert('No emails selected. Please select at least one email.', {
                    title: 'No emails selected',
                    closeText: 'Ok'
                });
            }
            var o365_ids = [];
            var gmail_ids = [];
            var dumpEvents = {};
            _(selected).map(function (id) {
                var item = $scope.responseIdsDict[id];
                if (item && item.entity_type == 'office365_emails_email' && !item.is_quarantined) {
                    o365_ids.push(id);
                } else if (item && item.entity_type == 'google_mail_email' && !item.is_quarantined) {
                    gmail_ids.push(id);
                }
                dumpEvents[id] = true;
            });
            if (o365_ids.length === 0 && gmail_ids.length === 0) {
                return console.log('No quarantine items.');
            }
            return modals.confirm({
                message: 'Are you sure you want to Quarantine the selected ' + selected.length + ' emails?',
                title: 'Quarantine Action',
                okText: 'Quarantine'
            }).then(function () {
                var entity_type = '';
                if (o365_ids.length > 0) {
                    entity_type = 'office365_emails_email';
                    manualActionDao.create(entity_type, o365_ids, angular.copy(actionName.quarantine[entity_type])).then(function () {
                    });
                }
                if (gmail_ids.length > 0) {
                    entity_type = 'google_mail_email';
                    manualActionDao.create(entity_type, gmail_ids, angular.copy(actionName.quarantine[entity_type])).then(function () {
                    });
                }
                _.extend(eventsUpdating, dumpEvents);
                // Refresh table
                return modals.confirm({
                    message: 'Action successful! It might take a few moments to update.',
                    title: 'Quarantine Successful!',
                    okText: 'Ok',
                    cancelText: null
                }).then(function () {
                    updateRowClasses();
                    $timeout(function () {
                        $scope.refreshTable(true);
                    }, 5000);
                }, function () {
                    updateRowClasses();
                    $timeout(function () {
                        $scope.refreshTable(true);
                    }, 5000);
                });
            });
        };
        $scope.allowQuarantineAllMatch = function () {
            return false || feature.enableMailExplorerQuarantineMatch;
        };
        $scope.quarantineMatchResults = function () {
            var mailsCount = $scope.tableHelper.getTotal();
            return modals.confirm({
                message: 'Are you sure you want to Quarantine all matching ' + mailsCount + ' emails?',
                title: 'Quarantine Action',
                okText: 'Quarantine'
            }).then(function () {
                if (queryFilters) {
                    mailExplorerDao.quarantineAllMatch(queryFilters).then(function (response) {
                    }).catch(function () {
                        modals.alert('The quarantine operation request has failed.', {
                            title: 'Quarantine Request Error',
                            closeText: 'OK'
                        });
                    });
                }
            });
        };
        $scope.isQuarantined = function () {
            var selected = $scope.tableHelper && $scope.tableHelper.getSelectedIdsArray();
            if (!selected || !selected.length) {
                return false;
            }
            var o365_ids = [];
            var gmail_ids = [];
            _(selected).map(function (id) {
                var item = $scope.responseIdsDict[id];
                if (item && item.entity_type == 'office365_emails_email' && item.is_quarantined) {
                    o365_ids.push(id);
                } else if (item && item.entity_type == 'google_mail_email' && item.is_quarantined) {
                    gmail_ids.push(id);
                }
            });
            return o365_ids.length !== 0 || gmail_ids.length !== 0;
        };
        $scope.release = function () {
            var selected = $scope.tableHelper && $scope.tableHelper.getSelectedIdsArray();
            if (!selected || !selected.length) {
                return modals.alert('No emails selected. Please select at least one email.', {
                    title: 'No emails selected',
                    closeText: 'Ok'
                });
            }
            var o365_ids = [];
            var gmail_ids = [];
            var dumpEvents = {};
            _(selected).map(function (id) {
                var item = $scope.responseIdsDict[id];
                if (item && item.entity_type == 'office365_emails_email' && item.is_quarantined) {
                    o365_ids.push(id);
                } else if (item && item.entity_type == 'google_mail_email' && item.is_quarantined) {
                    gmail_ids.push(id);
                }
                dumpEvents[id] = true;
            });
            if (o365_ids.length === 0 && gmail_ids.length === 0) {
                return console.log('No quarantined items.');
            }
            return modals.confirm({
                message: 'Are you sure you want to release the selected ' + selected.length + ' emails?',
                title: 'Release Action',
                okText: 'Release'
            }).then(function () {
                var entity_type = '';
                if (o365_ids.length > 0) {
                    entity_type = 'office365_emails_email';
                    manualActionDao.create(entity_type, o365_ids, angular.copy(actionName.release[entity_type])).then(function () {
                    });
                }
                if (gmail_ids.length > 0) {
                    entity_type = 'google_mail_email';
                    manualActionDao.create(entity_type, gmail_ids, angular.copy(actionName.release[entity_type])).then(function () {
                    });
                }
                _.extend(eventsUpdating, dumpEvents);
                // Refresh table
                return modals.confirm({
                    message: 'Action successful! It might take a few moments to update.',
                    title: 'Release Successful!',
                    okText: 'Ok',
                    cancelText: null
                }).then(function () {
                    updateRowClasses();
                    $timeout(function () {
                        $scope.refreshTable(true);
                    }, 5000);
                }, function () {
                    updateRowClasses();
                    $timeout(function () {
                        $scope.refreshTable(true);
                    }, 5000);
                });
            });
        };
        var tableColumns = [
            {
                id: 'entity_id',
                primary: true,
                hidden: true,
                order: 0
            },
            {
                id: 'received_at',
                label: 'Received',
                order: 1,
                converter: GMTtoLocalTimeConverter,
                format: 'time'
            },
            {
                id: 'is_quarantined',
                converter: BoolConverter,
                order: 2,
                label: 'Quarantined'
            },
            {
                id: 'subject',
                converter: EntityProfileLinkConverter,
                order: 3,
                label: 'Subject'
            },
            {
                id: 'nickname',
                order: 4,
                label: 'Sender Name'
            },
            {
                id: 'sender_address',
                order: 5,
                label: 'Sender Email'
            },
            {
                id: 'recipient',
                label: 'Recipients',
                order: 6,
                converter: 'normalListConverter',
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'recipients'
                }
            },
            {
                id: 'attachments',
                label: 'Attachments hash ',
                converter: 'attachmentListConverter',
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'attachments'
                }
            },
            {
                id: 'sender_ip',
                order: 7,
                label: 'Sender SMTP (IP)'
            },
            {
                id: 'sender_client_ip',
                order: 7,
                label: 'Client Sender IP'
            },
            {
                id: 'email_body_links',
                converter: 'listConverter',
                converterArgs: {
                    countPostfix: 'links',
                    collapseRest: true,
                    moreInPopup: true,
                    expanded: 2,
                    itemConverter: 'copyItemConverter'
                },
                label: 'Links'
            },
            {
                id: 'is_deleted_message',
                hidden: true,
                label: 'Show deleted'
            },
            {
                id: 'entity_type',
                hidden: true
            }
        ];
        var params = [
            {
                id: 'time_type',
                group: 1,
                order: 1,
                type: 'selector',
                enabled: true,
                data: 'last',
                variants: [
                    {
                        id: 'last',
                        label: 'Last'
                    },
                    {
                        id: 'range',
                        label: 'Range'
                    }
                ],
                label: 'Date received',
                style: { width: '100px' },
                noLabel: true,
                is_active: true
            },
            {
                id: 'last_date_amount',
                type: 'integer',
                min: 1,
                group: 1,
                order: 2,
                enabled: function () {
                    if ($scope.model.scopeParams.time_type) {
                        return $scope.model.scopeParams.time_type.data == 'last';
                    }
                },
                is_active: true,
                data: 1,
                label: 'Amount',
                noLabel: true,
                style: { width: '100px' }
            },
            {
                id: 'last_date_period',
                type: 'selector',
                group: 1,
                order: 3,
                enabled: function () {
                    if ($scope.model.scopeParams.time_type) {
                        return $scope.model.scopeParams.time_type.data == 'last';
                    }
                },
                is_active: true,
                data: $scope.pageContext === 'page' ? 'hours' : 'days',
                variants: [
                    {
                        id: 'hours',
                        label: 'Hours'
                    },
                    {
                        id: 'days',
                        label: 'Days'
                    },
                    {
                        id: 'months',
                        label: 'Months'
                    },
                    {
                        id: 'years',
                        label: 'Years'
                    }
                ],
                label: 'Last',
                noLabel: true,
                style: { width: '120px' }
            },
            {
                id: 'range_from',
                enabled: function () {
                    if ($scope.model.scopeParams.time_type) {
                        return $scope.model.scopeParams.time_type.data == 'range';
                    }
                },
                type: 'datetime',
                group: 1,
                order: 2,
                data: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
                // 2 = number of days back
                label: 'From',
                style: { width: '16%' },
                labelStyle: { width: '70px' }
            },
            {
                id: 'range_to',
                enabled: function () {
                    if ($scope.model.scopeParams.time_type) {
                        return $scope.model.scopeParams.time_type.data == 'range';
                    }
                },
                type: 'datetime',
                group: 1,
                order: 3,
                data: new Date(),
                label: 'To',
                style: { width: '16%' },
                labelStyle: { width: '70px' }
            },
            {
                id: 'include_quarantined',
                type: 'selector',
                variants: [
                    {
                        id: 'quarantined',
                        label: 'Display quarantined'
                    },
                    {
                        id: 'not_quarantined',
                        label: 'Display not quarantined'
                    },
                    {
                        id: 'both',
                        label: 'Display all'
                    }
                ],
                is_active: true,
                enabled: true,
                group: 1,
                order: 4,
                data: 'both',
                label: 'Quarantined Emails',
                style: { width: '350px' },
                labelStyle: { width: '135px' }
            },
            {
                id: 'received_at',
                label: 'Received',
                tableOrder: 1,
                converter: GMTtoLocalTimeConverter,
                format: 'time',
                hiddenInForm: true,
                notInSearch: true
            },
            {
                id: 'subject',
                isBlacklistCondition: true,
                type: 'string',
                enabled: true,
                converter: EntityProfileLinkConverter,
                group: 2,
                order: 1,
                tableOrder: 3,
                data: '',
                label: 'Subject',
                suggestMatching: true,
                match: 'contains'
            },
            {
                id: 'attach_md5',
                detailsId: 'attachments',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 4,
                enabled: true,
                data: '',
                label: 'Attachments hash ',
                formLabel: 'Attachments MD5'
            },
            {
                id: 'sender_server_ip',
                detailsId: 'sender_ip',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 8,
                tableOrder: 7,
                enabled: true,
                data: '',
                label: 'Sender SMTP (IP)',
                formLabel: 'Sender SMTP (IP)',
                valid: false,
                validation: {
                    regexp: {
                        value: ipRegex,
                        message: 'Please provide a valid Sender SMTP IP address'
                    }
                }
            },
            {
                id: 'sender_client_ip',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 5,
                tableOrder: 7,
                data: '',
                enabled: true,
                label: 'Client Sender IP',
                validation: {
                    regexp: {
                        value: ipRegex,
                        message: 'Please provide a valid Sender client IP address'
                    }
                }
            },
            {
                id: 'is_deleted_message',
                hidden: true,
                type: 'boolean',
                enabled: true,
                group: 2,
                order: 9,
                data: false,
                label: 'Show deleted'
            },
            {
                id: 'entity_id',
                primary: true,
                hidden: true,
                hiddenInForm: true,
                notInSearch: true
            },
            {
                id: 'entity_type',
                hidden: true,
                hiddenInForm: true,
                notInSearch: true
            }
        ];
        if (feature.MailExplorer2PartialMatching) {
            params.push({
                id: 'link',
                detailsId: 'email_body_links',
                exceptionRuleId: 'with_links_to_domains',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 7,
                enabled: true,
                data: '',
                label: 'Links',
                formLabel: 'Link in body',
                suggestMatching: true,
                match: 'contains'
            }, {
                id: 'from_name',
                detailsId: 'nickname',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 3,
                tableOrder: 4,
                enabled: true,
                data: '',
                label: 'Sender Name',
                suggestMatching: true,
                match: 'contains'
            }, {
                id: 'from_email',
                detailsId: 'sender_address',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 2,
                tableOrder: 5,
                data: '',
                enabled: true,
                label: 'Sender Email',
                suggestMatching: true,
                match: 'contains'
            }, {
                id: 'recipient',
                label: 'Recipients',
                class: 'param-recipients',
                type: 'string',
                converter: 'normalListConverter',
                group: 1,
                order: 5,
                enabled: true,
                is_active: true,
                tableOrder: 6,
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'recipients'
                },
                suggestMatching: true,
                match: 'contains',
                match_id: 'recipient'
            }, {
                id: 'from_domain',
                detailsId: 'sender_domain_suffix',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 6,
                enabled: true,
                data: '',
                label: 'Sender Domain',
                suggestMatching: true,
                match: 'contains',
                matchType: '1'
            });
        } else {
            params.push({
                id: 'link',
                detailsId: 'email_body_links',
                exceptionRuleId: 'with_links_to_domains',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 7,
                enabled: true,
                data: '',
                label: 'Links',
                formLabel: 'Link in body'
            }, {
                id: 'from_name',
                detailsId: 'nickname',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 3,
                tableOrder: 4,
                enabled: true,
                data: '',
                label: 'Sender Name'
            }, {
                id: 'from_email',
                detailsId: 'sender_address',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 2,
                tableOrder: 5,
                data: '',
                enabled: true,
                label: 'Sender Email'
            }, {
                id: 'recipient',
                label: 'Recipients',
                class: 'param-recipients',
                type: 'string',
                converter: 'normalListConverter',
                group: 1,
                order: 5,
                enabled: true,
                is_active: true,
                tableOrder: 6,
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'recipients'
                }
            }, {
                id: 'from_domain',
                detailsId: 'sender_domain_suffix',
                isBlacklistCondition: true,
                type: 'string',
                group: 2,
                order: 6,
                enabled: true,
                data: '',
                label: 'Sender Domain'
            });
        }
        $scope.$on('blacklist-open-modal', function (event, data) {
            return displayExceptionModal('blacklist');
        });
        $scope.params = _(params).chain().sortBy('order').value();
        $scope.options.columns = _(tableColumns).chain().sortBy('order').map(function (param) {
            return {
                id: param.id,
                text: param.label,
                validation: param.validation,
                converter: param.converter || simpleTooltipConverter,
                converterArgs: param.converterArgs,
                hidden: param.hidden,
                hiddenInForm: param.hiddenInForm,
                hiddenInTable: param.hiddenInTable
            };
        }).value();
        $scope.refreshTable = function (noIndicator) {
            eventsUpdating = {};
            if (!isFormValid()) {
                return;
            }
            $rootScope.me2EsScrollId = null;
            $scope.responseIdsDict = {};
            if ($scope.tableHelper) {
                $scope.tableHelper.reload(true, noIndicator);
            } else {
                initTable();
            }
        };
        configDao.param('mail_explorer2_with_es').then(function (value) {
            if (value === true) {
                $scope.enabledMe2ES = true;
            }
            setValues();
        });
        $scope.loading = false;
        $scope.loaded = true;
        var queryFilters = null;
        var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
        function makeFilters() {
            var temp_params = {};
            _($scope.params).chain().map(function (param) {
                if (param.id == 'include_quarantined') {
                    if (param.data === 'quarantined') {
                        temp_params.is_quarantined = true;
                    } else if (param.data === 'not_quarantined') {
                        temp_params.is_quarantined = false;
                    }
                }
                if (param.notInSearch) {
                    return;
                }
                if (param.type === 'datetime') {
                    temp_params[param.id] = moment(param.data).utc().format();
                    return;
                }
                if (param.is_active && param.enabled !== false && (param.data || param.data === false)) {
                    if (param.match) {
                        temp_params[(param.match_id || param.id) + '_matching'] = param.match;
                        if (param.exceptionRuleId === 'with_links_to_domains') {
                            temp_params.link_matching = param.match;
                        }
                    }
                    temp_params[param.id] = param.data;
                }
                if (param.hidden) {
                    temp_params[param.id] = param.data;
                }
            });
            if ($scope.specific_datetime) {
                temp_params.specific_datetime = $scope.specific_datetime;
            }
            if (temp_params.time_type == 'last') {
                var period = temp_params.last_date_period || 'days';
                var amount = temp_params.last_date_amount || 2;
                temp_params.range_from = moment().utc().subtract(amount, period).format();
                temp_params.range_to = moment().utc().format();
            }
            if ($scope.pageContext !== 'page') {
                temp_params.operator = $scope.operator ? 'or' : 'and';
            } else {
                temp_params.operator = 'and';
            }
            $scope.ruleToBeCreated = temp_params;
            return temp_params;
        }
        function isParamValid(param) {
            if (param.validation) {
                if (param.validation.required) {
                    if (param.data === '') {
                        return false;
                    }
                }
                if (param.validation.regexp && param.validation.regexp.value) {
                    if (!param.validation.regexp.value.test(param.data)) {
                        return false;
                    }
                }
            }
            return true;
        }
        function isFormValid() {
            var isValid = true;
            $scope.errorsList = [];
            $scope.params.forEach(function (param) {
                if (!param.is_active) {
                    return;
                }
                if (param.validation) {
                    if (param.validation.required) {
                        if (param.data === '') {
                            $scope.errorsList.push(param.validation.required.message);
                            isValid = false;
                            return;
                        }
                    } else {
                        if (param.data === '') {
                            return;
                        }
                    }
                    if (param.validation.regexp && param.validation.regexp.value) {
                        if (!param.validation.regexp.value.test(param.data)) {
                            isValid = false;
                            $scope.errorsList.push(param.validation.regexp.message);
                            return;
                        }
                    }
                }
            });
            return isValid;
        }
        function initTable() {
            $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                var q;
                queryFilters = makeFilters();
                if ($scope.mode === 'rule') {
                    q = apAvananExceptionsDao.blacklistItem(options.blacklistId).pagination(args.offset, args.limit);
                } else {
                    if ($scope.enabledMe2ES) {
                        q = mailExplorerDao.searchEmails2WithES(queryFilters);
                    } else {
                        q = mailExplorerDao.searchEmails2(queryFilters).pagination(args.offset, args.limit);
                    }
                }
                $scope.error = '';
                return q.after(function (response) {
                    if (response.data && response.data.scroll_id) {
                        $rootScope.me2EsScrollId = response.data.scroll_id;
                    }
                    $scope.responseRows = response.data.rows;
                    $scope.responseIdsDict = $scope.responseIdsDict || {};
                    _($scope.responseRows).map(function (item) {
                        $scope.responseIdsDict[item.entity_id] = item;
                    });
                    if ($scope.isEntityPageModal && !_($scope.currentEntityData).isEmpty() && !response.data.total_rows) {
                        response.data.rows.push($scope.currentEntityData);
                        response.data.total_rows += 1;
                    }
                }).converter(defaultListConverter, { columns: $scope.options.columns }).onRequestFail(function (error) {
                    if (error.status === 400 && error.data && error.data.message) {
                        $scope.error = error.data.message;
                        return $q.when({
                            data: {
                                rows: [],
                                total_rows: 0
                            }
                        });
                    } else {
                        return $q.reject(error);
                    }
                });
            }, function (tableModel) {
                $scope.tableModel = tableModel;
                $scope.totalEmails = $scope.tableHelper.getTotal();
                updateRowClasses();
                $scope.loading = false;
            });
        }
        function updateRowClasses() {
            if (!$scope.tableModel || !$scope.tableModel.data) {
                return;
            }
            _($scope.tableModel.data).each(function (row, idx) {
                $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                if (eventsUpdating[row[primaryColumn].originalText]) {
                    $scope.tableModel.rowClasses[idx].processing = true;
                } else {
                    delete $scope.tableModel.rowClasses[idx].processing;
                }
            });
        }
        function simpleTooltipConverter(text) {
            return '#' + JSON.stringify({
                display: 'text',
                text: text,
                tooltip: {
                    content: { text: text },
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    style: {
                        classes: 'qtip-standard ap-avanan-blacklist-tip',
                        def: false
                    }
                }
            });
        }
        function EntityProfileLinkConverter(text, columnId, event, args) {
            var url = routeHelper.getHref('profile', {
                entityType: event.entity_type,
                id: event.entity_id
            });
            url += '?hide_menu=1';
            var link = '#' + JSON.stringify({
                display: 'html',
                // href: url,
                text: '<a href="' + url + '" class="action-link" target="_blank">' + (event[columnId] || 'N/A') + '</a>',
                tooltip: event[columnId],
                class: 'display-inline-block--customized'
            });
            return link;
        }
        function BoolConverter(text, columnId, event, args) {
            return event.is_quarantined ? 'Yes' : 'No';
        }
        function GMTtoLocalTimeConverter(text, columnId, event, args) {
            var date = moment.utc(text).local().format('LL') + ' ' + moment.utc(text).local().format('LTS');
            return '#' + JSON.stringify({
                display: 'text',
                text: date,
                tooltip: {
                    content: { text: date },
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    style: {
                        classes: 'qtip-standard ap-avanan-blacklist-tip',
                        def: false
                    }
                }
            });
        }
        $scope.closeModal = function () {
            if ($rootScope.closeMailExplorerModal && $scope.pageContext != 'page') {
                $rootScope.closeMailExplorerModal();
            }
        };
        $scope.toggleFilters = function (e) {
            var $accordion = $(e.currentTarget);
            if ($accordion.hasClass('expanded')) {
                $accordion.removeClass('expanded');
            } else {
                $accordion.addClass('expanded');
            }
        };
    }]);
}());